import { AISingleStar } from '@app/components/icons/ai-single-star';
import React from 'react';

type AiStarLoaderProps = {
  scale?: number;
  showShine?: boolean;
};

export const AiStarLoader: React.FC<AiStarLoaderProps> = ({
  scale = 1,
  showShine = false,
}) => {
  return (
    <div
      className="w-16 h-16 relative"
      style={{ transform: `scale(${scale})` }}
    >
      {showShine && (
        <div className="w-10 h-10 rounded-full border absolute z-0 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#FF5C00] opacity-40 blur-lg" />
      )}
      <div className="absolute z-10 top-0 right-0">
        <div className="animate-star-float-1">
          <AISingleStar className="size-5 animate-star-spin-1" />
        </div>
      </div>
      <div className="absolute z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="animate-star-float-2">
          <AISingleStar className="size-10 animate-star-spin-2" />
        </div>
      </div>
    </div>
  );
};
